<template lang="pug">
  form(@submit="submit($event, 'componentes', !showSaveButton)")
    md-button.md-raised(type="button" @click="addSubproject()") Agregar Sub-Proyecto
    div(v-if="formData && showSaveButton")
      template(v-for="(v, index) in $v.formData.$each.$iter")
        div(:key="`componentes-${index}`" v-if="v")
          md-button.md-raised.md-accent(type="button" @click="showDialogBeforeDelete(index)") Eliminar Sub-Proyecto
          h2 Sub-proyecto Nº {{ parseInt(index) + 1 }}
          md-field(:class="getValidationClass(`formData.$each/${index}/name`)", md-clearable)
            label Nombre del proyecto
            md-input(v-model="v.name.$model")
            span.md-error(v-if="!v.name.required") Requerido
          md-field(:class="getValidationClass(`formData.$each/${index}/slogan`)", md-clearable='')
            label Slogan
            md-input(v-model='v.slogan.$model', :disabled='sending')
          .text-box-editor-container
            label Descripción
            TextBoxEditor(v-model="v.descripcion.$model")
          h3 Ficha técnica
          md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/ubicacion`)", md-clearable)
            label Ubicación
            md-input(v-model="v.fichaTecnica.ubicacion.$model", :disabled="sending")
          md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/superficie`)", md-clearable)
            label Superficie
            md-input(v-model="v.fichaTecnica.superficie.$model", :disabled="sending")
          md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/fuenteFinanciacion`)", md-clearable)
            label Fuente Financiación
            md-input(v-model="v.fichaTecnica.fuenteFinanciacion.$model", :disabled="sending")
          md-divider
          md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/costoEstimativo`)", md-clearable)
            label Costo estimativo {{ v.fichaTecnica.costoEstimativo.$model }}
            md-input(v-model="v.fichaTecnica.costoEstimativo.$model", :disabled="sending" @keyup.native="inputValueThousandSeparatorFormat($event, val => { v.fichaTecnica.costoEstimativo.$model = val })")
          md-field.costo-moneda-select(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/costoMoneda`)")
            label Moneda
            md-select(v-model="v.fichaTecnica.costoMoneda.$model" name="costoMoneda" id="costoMoneda")
              md-option(:value="moneda" :key="moneda" v-for="moneda in monedas") {{ moneda }}
            span.md-helper-text Moneda del monto cargado
          md-divider
          br
          .block.ente-ejecutor-container(:class="getValidationClass(`formData.$each/${index}/fichaTecnica.enteEjecutor`)")
            .block
              label Ente ejecutor
            .md-layout.md-gutter
              .md-layout-item.md-size-33.md-xsmall-size-100.md-medium-size-50(:key="item.text", v-for="item in executors")
                md-checkbox(v-model="models[`executors${index}`]", :value="item.text", @change="changeExecutors($event, index)") {{item.text}}
            span.md-error(v-if="!v.fichaTecnica.enteEjecutor.required") Requerido
          md-divider
          br
          .md-layout.md-gutter(v-if="v.fichaTecnica && v.fichaTecnica.status")
            .md-layout-item.md-size-100
              | Estados por año
            .md-layout-item.md-small-size-100
              md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica.status.planification`)", md-clearable)
                label Planificación
                md-input(type='number', v-model='v.fichaTecnica.status.planification.$model', :disabled='sending')
                span.md-error(v-if='!v.fichaTecnica.status.planification.required') Requerido
                span.md-error(v-if='!v.fichaTecnica.status.planification.minLength') El año debe poseer 4 números
            .md-layout-item.md-small-size-100
              md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica.status.execution`)", md-clearable)
                label En ejecución
                md-input(type='number', v-model='v.fichaTecnica.status.execution.$model', :disabled='sending')
                span.md-error(v-if='!v.fichaTecnica.status.execution.required') Requerido
                span.md-error(v-if='!v.fichaTecnica.status.execution.minLength') El año debe poseer 4 números
            .md-layout-item.md-small-size-100
              md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica.status.finished`)", md-clearable)
                label Finalización
                md-input(type='number', v-model='v.fichaTecnica.status.finished.$model', :disabled='sending')
                span.md-error(v-if='!v.fichaTecnica.status.finished.required') Requerido
                span.md-error(v-if='!v.fichaTecnica.status.finished.minLength') El año debe poseer 4 números
          md-divider
          br
          .block(:class="getValidationClass(`formData.$each/${index}/fichaTecnica.tipo`)")
            .block
              label Tipos de proyecto
            .md-layout.md-gutter
              .md-layout-item.md-size-33.md-xsmall-size-100.md-medium-size-50(:key="item.text", v-for="item in types")
                md-checkbox(v-model="models[`types${index}`]", :value="item.text", @change="changeTypes($event, index)") {{item.text}}
            span.md-error(v-if="!v.fichaTecnica.tipo.required") Requerido
          md-divider
          md-field(:class="getValidationClass(`formData.$each/${index}/fichaTecnica/familias`)", md-clearable)
            label Cantidad de familias residentes en el área
            md-input(v-model="v.fichaTecnica.familias.$model", :disabled="sending")
          md-divider
          br

          .images-container(:class="getValidationClass(`formData.$each/${index}/images`)")
            div(v-if="v.images")
              template(v-for="(img, idx) in v.images.$each.$iter")
                div
                  ButtonWithAlertDialog(
                    title="Eliminar imagen"
                    message="¿ Está seguro que desea eliminar esta imagen ?"
                    @on-confirm="removeImage(index, idx)"
                  ) Eliminar imagen
                img(
                  :ref="`subprojectImages${index}`"
                  :id="`subproject-image-${index}-${idx}`"
                  :src="getImageSrcIfExist(img.$model, index, idx)"
                  @load="onLoadImage"
                )
                custom-input-file(
                  clearable
                  label="Cargar imagen"
                  v-model="img.$model"
                  :error-messages="getMessageErrors(`formData.$each/${index}/images/$each/${idx}`)"
                  :disabled="sending"
                  accept="image/*"
                  @change-files="showImages($event, index, idx)"
                  @input="img.$touch()"
                  @blur="img.$touch()"
                )

            v-btn(@click="addImage(index)") Agregar imagen
    md-button.md-raised.md-primary(v-show="!isCreateView && showSaveButton" type="submit" ref="saveButton") Guardar

    custom-dialog-confirm(
      :active="showDeleteDialog"
      title="Eliminar sub-proyecto"
      content="¿ Está seguro que desea eliminar este sub-proyecto ?"
      confirm-text="Si"
      cancel-text="No"
      @confirm="deleteSubproject"
      @cancel="hideDeleteSubProjectDialog"
    )
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { clone } from '@/utils/form.js'
import { hasData } from '@/utils/object.js'
import { monedas, projectFilterObject, STATIC_FILES_GATEWAY_BASE_URL } from '@/constants'
import projectFormMixin from '@/mixins/project-form.js'
import thousandSeparatorMixin from '@/mixins/thousand-separator.js'

const initValue = {
  name: '',
  slogan: '',
  descripcion: '',
  images: [],
  fichaTecnica: {
    familias: 0,
    costoEstimativo: 0,
    costoMoneda: clone(monedas[0]),
    enteEjecutor: [],
    fuenteFinanciacion: '',
    status: {
      planification: '',
      execution: '',
      finished: ''
    },
    superficie: '',
    tipo: [],
    ubicacion: ''
  }
}

export default {
  mixins: [ projectFormMixin, thousandSeparatorMixin ],
  props: {
    isCreateView: {
      type: Boolean,
      default: false
    },
    customValidations: {
      type: Object,
      default: () => ({})
    },
    code: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    showSaveButton: false,
    showDeleteDialog: false,
    indexSubProjectToDelete: null,
    models: {
      types0: [],
      executors0: []
    },
    monedas,
    executors: projectFilterObject.executors,
    status: projectFilterObject.status,
    types: projectFilterObject.types,
    files: []
  }),
  validations () {
    return {
      formData: {
        $each: {
          name: {
            required
          },
          slogan: { },
          descripcion: { },
          images: {
            $each: { }
          },
          fichaTecnica: {
            familias: { },
            costoEstimativo: { },
            costoMoneda: { },
            enteEjecutor: { required },
            fuenteFinanciacion: { },
            superficie: { },
            status: {
              planification: {
                required,
                minLength: 4
              },
              execution: {
                required,
                minLength: 4
              },
              finished: {
                required,
                minLength: 4
              }
            },
            tipo: { required },
            ubicacion: { }
          },
          ...this.customValidations
        }
      }
    }
  },
  methods: {
    getFichaTecnicaTipo (fichaTecnica) {
      return fichaTecnica.tipo && fichaTecnica.tipo.length ? clone(fichaTecnica.tipo) : []
    },
    getFichaTecnicaExecutores (fichaTecnica) {
      return fichaTecnica.enteEjecutor && fichaTecnica.enteEjecutor.length ? clone(fichaTecnica.enteEjecutor) : []
    },
    changeTypes (event, idx) {
      if (!this.formData[idx]) this.formData[idx] = clone(initValue)
      this.formData[idx].fichaTecnica.tipo = event
    },
    changeExecutors (event, idx) {
      if (!this.formData[idx]) this.formData[idx] = clone(initValue)
      this.formData[idx].fichaTecnica.enteEjecutor = event
    },
    addSubproject () {
      this.formData.push(clone(initValue))
      this.showSaveButton = true
    },
    showDialogBeforeDelete (index) {
      this.indexSubProjectToDelete = index
      this.showDeleteDialog = true
    },
    hideDeleteSubProjectDialog () {
      this.indexSubProjectToDelete = null
      this.showDeleteDialog = false
    },
    deleteSubproject () {
      if (this.indexSubProjectToDelete !== null) {
        this.formData.splice(this.indexSubProjectToDelete, 1)
        if (!(this.formData && this.formData.length)) {
          this.showSaveButton = false
          this.hideDeleteSubProjectDialog()
        }
      }
    },
    initDataWhenValuePropIsAssignedFirstTime (value) {
      const self = this
      if (hasData(value)) {
        value.forEach((s, idx) => {
          if (hasData(s.fichaTecnica)) {
            self.models = {
              ...self.models,
              [`types${idx}`]: self.getFichaTecnicaTipo(s.fichaTecnica),
              [`executors${idx}`]: self.getFichaTecnicaExecutores(s.fichaTecnica)
            }
          }
        })
        this.showSaveButton = true
      } else {
        this.showSaveButton = false
      }
    },
    // methods for images
    getImageSrcInFile (file) {
      return new Promise((resolve, reject) => {
        if (!file) return reject(new Error('File not found'))
        if (!FileReader) return reject(new Error('FileReader not supported'))
        const fr = new FileReader()
        fr.onload = () => resolve(fr.result)
        fr.readAsDataURL(file)
        if (fr.result) resolve(fr.result)
      })
    },
    showImages (event, subprojectIdx, imageIdx) {
      if (event && event.length) {
        const self = this
        const file = event[0]
        this.getImageSrcInFile(file).then(imgSrc => {
          const subprojectImageEl = self.$refs[`subprojectImages${subprojectIdx}`][imageIdx]
          subprojectImageEl.src = imgSrc
          if (!self.files[subprojectIdx]) self.files[subprojectIdx] = { images: [] }
          self.files[subprojectIdx].images[imageIdx] = file
          self.$set(self.formData[subprojectIdx].images, imageIdx, file.name)
          self.$emit('input', self.formData)
          self.$emit('on-change-files', self.getFilesToEmit('images'))
        }).catch(err => console.warn(err))
      }
    },
    getImageSrcIfExist (src, subprojectIdx, imageIdx) {
      const file = this.files[subprojectIdx] && this.files[subprojectIdx].images[imageIdx]
      if (file) {
        this.getImageSrcInFile(file).then(imgSrc => { if (imgSrc) this.$refs[`subprojectImages${subprojectIdx}`][imageIdx].src = imgSrc })
        return ''
      }
      if (src && typeof src === 'string') return `${STATIC_FILES_GATEWAY_BASE_URL}/${this.code}/images/${src}`
    },
    onLoadImage (event) {
      this.$emit('on-change-tab-height', {})
    },
    addImage (subprojectIdx) {
      this.formData[subprojectIdx].images.push('')
    },
    removeImage (subprojectIdx, imageIdx) {
      if (this.files[subprojectIdx]) {
        this.$set(this.files, subprojectIdx, {
          ...this.files[subprojectIdx],
          images: this.files[subprojectIdx].images.filter((v, i) => i !== +imageIdx)
        })
      }
      this.$set(this.formData, subprojectIdx, {
        ...this.formData[subprojectIdx],
        images: this.formData[subprojectIdx].images.filter((v, i) => i !== +imageIdx)
      })
    },
    getFilesToEmit (type) {
      const files = { [type]: [] }
      this.files.forEach(allTypeFile => {
        if (!allTypeFile[type] || !allTypeFile[type].length) return
        allTypeFile[type].forEach(file => {
          if (!file) return
          files[type].push(file)
        })
      })
      return files
    }
    // end methods for images
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/edit-project-form-style'
</style>
